// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"4d7166c7","255":"6bd17ae0","626":"4c68a991","739":"94ade9a8","853":"a040744e","904":"2ac73fa3"}[chunkId] + ".chunk.js";
};